import { render, staticRenderFns } from "./NormalSearchNav279.vue?vue&type=template&id=b08a47bc&scoped=true&"
import script from "./NormalSearchNav279.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav279.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08a47bc",
  null
  
)

export default component.exports